export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderConversations@3x.png";